import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './CTASection.module.scss';

interface CTASectionProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title = 'HAVE AN IDEA WORTH BUILDING?',
  primaryLabel = "LET'S MAKE IT REAL.",
  primaryTo = '/contact',
}) => {
  return (
    <section className={`${styles.ctaSection} dark-section`} id="cta">
      <div className="torn-edge-top" />
      <div className="concentric-circles" />
      <div className="container">
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className={styles.heading}>{title}</h2>
          <div className="gradient-line"></div>
          <Link to={primaryTo} className={styles.ctaLink}>
            {primaryLabel} <ArrowRight size={32} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
